<template>
  <v-layout
    v-if="status === 'loading'"
    :style="`height: ${height}px;`"
    align-center
    justify-center
    fill-height
  >
    <v-progress-circular color="primary" indeterminate />
  </v-layout>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    status: {
      type: String,
      default: 'loading'
    },
    height: {
      type: Number
    }
  }
}
</script>
